import { all, call, debounce, fork, getContext, put, race, select, take, takeEvery } from 'redux-saga/effects';
import { damzOffline, damzOnline } from '../actions/initialization';
import { buffers, eventChannel } from 'redux-saga';
import ddt from '@wix/da-ddt';
import { addActivityQueue, clearActivityQueue, onActivity, sendAlertAndUpdateDrawer } from '../actions/global';
import { refreshCounter } from '../actions/counter';
import { getActivityRoomQueue } from '../selectors/global';
import { activityUpdateFrequencyMs, drawerStreamId } from '../../constants';
import uniq from 'lodash/uniq';
import { roomFetchToRoomItem } from '../helpers';
import { getDrawerActiveFilter } from '../selectors/drawer';
import { deleteItems, insertItemsAtOffsetAndSetCursor } from '@wix/da-shared-react/pkg/Stream/withCursor/actions';
function* createSagaChannel(userChannel, client) {
    return eventChannel((emitter)=>{
        userChannel.on('broadcast', {
            event: 'activity'
        }, (data)=>{
            emitter(data);
        }).subscribe();
        return ()=>{
            client.removeChannel(userChannel);
        };
    }, buffers.expanding());
}
function* listenToGlobalChannel() {
    const client = yield getContext('supaClient');
    const damzConfig = yield getContext('damzConfig');
    if (!damzConfig.userChannel) {
        // TODO log error
        return;
    }
    const userChannel = client.realtime.channel(`user:${damzConfig.userChannel}`, {
        config: {
            broadcast: {
                ack: false,
                self: false
            }
        }
    });
    const sagaChannel = yield call(createSagaChannel, userChannel, client);
    while(true){
        try {
            const payload = yield race({
                chan: take(sagaChannel),
                offline: take(damzOffline)
            });
            if (payload.offline) {
                sagaChannel.close();
                break;
            }
            if (payload.chan) {
                if (payload.chan.event === 'activity') {
                    yield put(onActivity(payload.chan.payload.room_id));
                }
            }
        } catch (err) {
            ddt.error('damz', 'Realtime processing error', err);
            sagaChannel.close();
        }
    }
}
function* handleActivity(action) {
    // Queue rooms updates
    yield put(addActivityQueue(action.payload.room_id));
    // throttled call to get global counter
    yield put(refreshCounter());
    // debounced call to alerts and drawer updates
    yield put(sendAlertAndUpdateDrawer());
}
function* handleActivityAlerts() {
    const room_ids = yield select(getActivityRoomQueue);
    if (room_ids.length === 0) {
        return;
    }
    // TODO Logic to set the window title and favicon here
    // Fetch the updated rooms
    const client = yield getContext('supaClient');
    const response = yield client.rpc('get_conversations_by_room_id', {
        p_room_ids: uniq(room_ids)
    });
    if (response.data.length > 0) {
        const newItems = roomFetchToRoomItem(response.data);
        const filter = yield select(getDrawerActiveFilter);
        const streamId = `${drawerStreamId}${filter}`;
        // Remove the updated one
        yield put(deleteItems({
            streamId,
            items: newItems,
            doNotUpdateNextOffset: true,
            isEqual: (item1, item2)=>{
                return item1.room.room_id === item2.room.room_id;
            }
        }));
        // Add new to the HEAD
        yield put(insertItemsAtOffsetAndSetCursor({
            streamId,
            items: newItems,
            offset: 0
        }));
    }
    yield put(clearActivityQueue());
}
/**
 * Listens to realtime events this user might be interested in
 */ export function* globalSaga() {
    yield take(damzOnline); // wait for online to happen
    yield all([
        fork(listenToGlobalChannel),
        takeEvery(onActivity, handleActivity),
        debounce(activityUpdateFrequencyMs, sendAlertAndUpdateDrawer, handleActivityAlerts)
    ]);
}

//# sourceMappingURL=global.js.map